"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiTitle = void 0;
const react_1 = require("react");
const React = require("react");
require("./kpi-title.less");
class KpiTitle extends react_1.Component {
    render() {
        const { label = "", label2 = "", subLabel = "", subLabel2 = "", subLabel3 = "", editPatient = "", viewHistory = false, viewNotes = false } = this.props;
        return (React.createElement("div", { className: "kpi-title" },
            React.createElement("div", { className: "kpi-title__row" },
                React.createElement("div", { className: "kpi-title__label" },
                    label,
                    " ",
                    label2.length ? React.createElement("span", { style: { fontSize: ".9rem" } }, label2) : "")),
            React.createElement("div", { className: "kpi-title__label-container " },
                React.createElement("div", { className: "kpi-title__row" },
                    subLabel && (React.createElement("div", { className: "kpi-title__item" },
                        React.createElement("div", { className: "kpi-title__sub-label" }, subLabel))),
                    subLabel && subLabel2 && React.createElement("div", { className: "kpi-title__divider" }),
                    subLabel2 && (React.createElement("div", { className: "kpi-title__item" },
                        React.createElement("div", { className: "kpi-title__sub-label2" }, subLabel2))),
                    subLabel && subLabel2 && subLabel3 && (React.createElement("div", { className: "kpi-title__divider" })),
                    subLabel3 && (React.createElement("div", { className: "kpi-title__item" },
                        React.createElement("div", { className: "kpi-title__sub-label3" }, subLabel3))),
                    subLabel && viewHistory && React.createElement("div", { className: "kpi-title__divider" }),
                    viewHistory && (React.createElement("div", { className: "kpi-title__item" },
                        React.createElement("a", { className: "kpi-title__view-history" }, "View History"))),
                    (subLabel || viewHistory) && viewNotes && (React.createElement("div", { className: "kpi-title__divider" })),
                    viewNotes && (React.createElement("div", { className: "kpi-title__item" },
                        React.createElement("a", { className: "kpi-title__view-notes" }, "View Notes")))),
                React.createElement("div", { className: "kpi-title__row", style: { marginRight: '7pc' } }, editPatient ? (React.createElement("div", { className: "kpi-title__item" },
                    React.createElement("div", { className: "kpi-title__edit-patient" }, editPatient))) : null)),
            this.props.children));
    }
}
exports.KpiTitle = KpiTitle;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-title/kpi-title.tsx
// module id = 2785
// module chunks = 0 1